import { ApolloClient, ApolloLink, Context, InMemoryCache, NormalizedCacheObject } from '@apollo/client';

import AuthService from '../services/AuthService';
import TenantService from './TenantService';
import createUploadLink from "apollo-upload-client/createUploadLink.mjs";
import { setContext } from '@apollo/client/link/context';

class ApolloClientService {
  private _clients: {
    [endpoint: string]: ApolloClient<NormalizedCacheObject>;
  } = {};

  public create(
    graphQLQueryEndpoint?: string
  ): ApolloClient<NormalizedCacheObject> {
    if (this._clients[graphQLQueryEndpoint]) {
      return this._clients[graphQLQueryEndpoint];
    }
    const authLink = setContext(async (_, { headers }) => {
      const token = AuthService.getAccessToken();

      const context: Context = {
        headers: {
          ...headers,
          authorization: token ? `Bearer ${token}` : ''
        }
      };

      const apiKey = AuthService.ApiKey;
      if (apiKey) {
        context.headers['x-tenant'] = TenantService.Tenant;
        context.headers['x-api-key'] = apiKey;
      }
      return context;
    });

    const cache = new InMemoryCache({ addTypename: false });

    this._clients[graphQLQueryEndpoint] = new ApolloClient({
      cache,
      link: ApolloLink.from([
        authLink,
        createUploadLink({ uri: graphQLQueryEndpoint })
      ])
    });

    return this._clients[graphQLQueryEndpoint];
  }
}

export default new ApolloClientService();
